import homePage from "./views/home-page.vue"
import contactPage from "./views/contact-page.vue"
import AboutPage from "./views/about-page.vue";
import ShowroomPage from "./views/showroom-page.vue";

import NewsPage from "./views/news-page.vue";
    import NewsCmp from "./components/news/news-post-cmp.vue";
    import AllNewsCmp from "./components/news/all-news-cmp.vue";

import ServicePage from "./views/service-page.vue";
    import RequestQuoteCmp from "./components/service/request-quote-cmp.vue";
    import AfterSalesCmp from "./components/service/after-sales-cmp.vue";
    import MaintenanceCmp from "./components/service/maintenance-cmp.vue";
    import TestDriveCmp from "./components/service/test-drive-cmp.vue";
    import FleetSolutionsCmp from "./components/service/fleet-solutions-cmp.vue";

import LoginPage from "./views/login-page.vue";
import ContentMangmentPage from "./views/new-post-page.vue";
import UpdatePostPage from "./views/update-post-page.vue";




export const routes = [
    { path: '/', component: homePage },
    { path: '/contact', component: contactPage },
    { path: '/about', component: AboutPage },
    { path: '/showroom', component: ShowroomPage },
    { path: '/admin/login', name: 'cmsLogin', component: LoginPage },
    { path: '/admin/newpost', name: "newPost", component: ContentMangmentPage },
    { path: '/admin/updatepost', name: "updatePost", component: UpdatePostPage },
    { path: '/services',
        component: ServicePage,
        redirect: '/services/request-quote', // default child
        children: [
            { path: 'request-quote', component: RequestQuoteCmp },
            { path: 'after-sales', component: AfterSalesCmp },
            { path: 'maintenance', component: MaintenanceCmp },
            { path: 'test-drive', component: TestDriveCmp },
            { path: 'fleet-solutions', component: FleetSolutionsCmp },
        ],
    },

    {
        path: '/news',
        component: NewsPage,
        redirect: '/news', // default child
        children: [
            { path: '', component: AllNewsCmp }, // display the news menu
            { path: ':newsKeyWord', component: NewsCmp }, // display single post choosen
        ],
    },
    
    { path: '*', redirect: '/' },
];